import { Injectable } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Injectable({ providedIn: 'root' })
export class ScreenReaderAnnouncerService {
  private pendingMessage: string | null = null;

  constructor(private liveAnnouncer: LiveAnnouncer) {}

  /**
   * Announce a loading message after a short delay.
   */
  announce(message: string): void {
    this.pendingMessage = message;
    setTimeout(() => {
      if (this.pendingMessage === message) {
        this.liveAnnouncer.announce(message, 'polite');
      }
    }, 500);
  }

  /**
   * Announce a completion message.
   * If a loading message was announced, waits 3s so SR finishes reading it.
   * If the loading message hasn't fired yet (fast load), skips it and
   * announces only the completion message.
   */
  announceAfterLoading(message: string): void {
    if (this.pendingMessage) {
      // Loading message hasn't been cleared yet — it may or may not have fired.
      // Clear it so it doesn't fire after the completion message.
      this.pendingMessage = null;
      // Wait enough time for loading to finish being read, then announce completion
      setTimeout(() => {
        this.liveAnnouncer.announce(message, 'polite');
      }, 3500);
    } else {
      // No pending loading message — announce directly
      setTimeout(() => {
        this.liveAnnouncer.announce(message, 'polite');
      }, 500);
    }
  }
}
